import script from "./MaisDados.vue?vue&type=script&setup=true&lang=js"
export * from "./MaisDados.vue?vue&type=script&setup=true&lang=js"

import "./MaisDados.vue?vue&type=style&index=0&id=56e89496&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56e89496"]])

export default __exports__